import React, { Fragment, useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router';
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { Loader } from 'semantic-ui-react';
import { AuthContext } from "../context/auth"

const Activation = () => {
    const [activationResult, setactivationResult] = useState("");
    const params = useParams();
    const token = params.token;
    const context = useContext(AuthContext);

    const [activateUser, { loading }] = useMutation(ACTIVATE_USER, {
        onCompleted: (data) => {
            setactivationResult(data.activateUser);
            context.logout();
        },
        onError(err){
            setactivationResult(err.graphQLErrors[0].message);
        },
        variables : { usernameHashed: token }
    });

    useEffect(()=>{
        activateUser();
    }, [])
    

    return(
    <Fragment>
        <h1>Account Activation</h1>
        {loading ? <Loader active inline/> : <h4 id="activation-result">{activationResult}</h4> }
    </Fragment>
    );
}

const ACTIVATE_USER = gql`
    mutation activateUser(
        $usernameHashed: String!
    ) {
        activateUser(
            usernameHashed: $usernameHashed
        )
    }
`;

export default Activation;